import React from 'react'
import { Link } from 'react-router-dom'

import LinearLoader from '../UI/LinearLoader'
import PageTitle from '../UI/PageTitle'
import ErrorDialog from '../UI/ErrorDialog'

import { niceCount } from '../../lib/formats.js'
import auth from '../../stores/auth.js'
import errors from '../../lib/errors.js'

import Resource from '../../stores/resource'
const ProjectStore = Resource('projects')

class Dashboard extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      userId: auth.loggedIn() ? auth.user().id : null,
      userName: auth.loggedIn() ? auth.user().firstName : 'there',
      projects: [],
      error: '',
      loading: true
    }
  }

  componentWillMount() {
    if (!this.state.userId) return

    // Only show active projects
    const activeStates = [
      'request',
      'quoted',
      'awarded',
      'production',
      'review',
      'delivery'
    ]

    ProjectStore.findAll({ userId: this.state.userId, states: activeStates })
      .then(result => this.setState({ projects: result.data, loading: false }))
      .catch(error =>
        this.setState({ error: errors.unpack(error), loading: false })
      )
  }

  _closeErrorDialog = () => this.setState({ error: '', loading: true })

  render() {
    const { error, loading, projects, userName } = this.state

    if (loading) return <LinearLoader />
    if (error)
      return (
        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}
        >
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      )

    return (
      <section>
        <PageTitle>Hello {userName}!</PageTitle>

        {projects.length > 0 && (
          <section>
            <h2>
              You have{' '}
              {niceCount(projects.length, 'active project', 'active projects')}{' '}
              assigned to you.
            </h2>
            <h4>
              Go to the <Link to="/projects">projects page</Link> to see your
              projects.
            </h4>
          </section>
        )}

        {projects.length === 0 && (
          <section>
            <h2>There are no active projects assigned to you right now.</h2>
            <h4>
              You can <Link to="/projects/new">create a new one</Link> or go
              grab a cup of coffee!
            </h4>
          </section>
        )}
      </section>
    )
  }
}

export default Dashboard



// WEBPACK FOOTER //
// ./src/components/Users/Dashboard.jsx